module.exports = __webpack_public_path__ + "img/header-diamondJewelryBudgetHigh.48127a4.jpg";